module.exports = __webpack_public_path__ + "img/normal.669d41d6.png";